import { useContext } from "react";
import { LearnLastActivityContext } from "../context";
export var useLearnLastActivityContext = function useLearnLastActivityContext() {
  var context = useContext(LearnLastActivityContext);
  if (context === undefined) {
    throw new Error('useLearnLastActivityContext must be used within a LastActivityProvider component');
  }
  return context;
};